import { useEffect, useRef, useState } from 'react'
import './styles.scss'
import Loading from '../Loading'

interface FilterBaseI {
  id: string
  name: string
  selected: boolean
}

interface InputSelectBaseProps {
  filterBases: FilterBaseI[]
  handleFilter: React.ChangeEventHandler<HTMLInputElement>
  isLoadingBases: boolean
}

function InputSelectBase({
  filterBases,
  handleFilter,
  isLoadingBases,
}: InputSelectBaseProps) {
  const [filterOpen, setFilterOpen] = useState<boolean>(false)
  const filterDivRef = useRef<HTMLDivElement>(null)
  const filterCheckBoxesRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !(filterDivRef.current?.contains(event.target as Node) ?? false) &&
        !(filterCheckBoxesRef.current?.contains(event.target as Node) ?? false)
      ) {
        setFilterOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <>
      <div
        className={`container-filter ${filterOpen ? 'open' : ''}`}
        onClick={() => {
          setFilterOpen(!filterOpen)
        }}
        ref={filterDivRef}
      >
        {isLoadingBases ? (
          <Loading size="small" />
        ) : (
          <>
            <h3>Filtro</h3>
            <svg
              className="icon"
              width="12"
              height="17"
              viewBox="0 0 25 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.6816 2L12.3409 14.3916L2.00009 2"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        )}
      </div>
      {filterOpen && (
        <div ref={filterCheckBoxesRef} className="container-selectBases">
          <label id="filter-label">Bases</label>
          <ul id="filter-bases-list">
            {filterBases.map((base) => (
              <li key={base.name}>
                <input
                  type="checkbox"
                  name={base.name}
                  id={base.id}
                  checked={base.selected}
                  onChange={handleFilter}
                />
                <label htmlFor={base.id}>{base.name}</label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

export default InputSelectBase
